import { Component, Inject } from '@angular/core';
import { NavController } from '@ionic/angular';
import { ApplicationFacade } from '@ridango/components';
@Component({
    templateUrl: './faq-page.component.html',
    styleUrls: ['./faq-page.component.scss']
})
export class FaqPageComponent {
    isChannelMobile = false;
    assetsPath$ = this.applicationFacade.assetsPath$;
    constructor(
        @Inject('ENV') public env: any,
        private navCtrl: NavController,
        public applicationFacade: ApplicationFacade
    ) {
        this.isChannelMobile = this.env.CHANNEL === 'mobile';
    }

    goBack(): void {
        this.navCtrl.back();
    }
}
